import React from 'react'
import {ClipLoader} from 'react-spinners'

const Loader = () => {
  return (
    <div className="loaderContainer"><ClipLoader size={100} color='#A93A7C' /></div>
  )
}

export default Loader